import {useForm, useFieldArray} from "react-hook-form";
import Select from 'react-select';
import * as React from 'react';
import {ApprovalRequest, Approvers, Data, ProposalApprovalRequirement, Staff} from "./types.ts";
import {ApprovalRequestRow} from "./ApprovalRequestRow.tsx";


export function ApproversSection(
    {
        queueMode,
        data,
        approvers,
        disabled,
        issues,
        currentProposalValue,
        proposalValueRequiringTwoApprovals,
        dateApproved,
        approvalRequirementList,
        statusList
    }:
        {
            queueMode: boolean,
            data: Data,
            approvers: Approvers,
            disabled: boolean,
            issues: { [key: string]: string[] },
            currentProposalValue: number,
            proposalValueRequiringTwoApprovals: number,
            dateApproved: string,
            approvalRequirementList: ProposalApprovalRequirement[],
            statusList: string[]
        }) {

    const proposalApprovalRequestsWithGenerated = [...data.proposalApprovalRequests];
    approvalRequirementList.forEach(requirement => {
        console.log(requirement);
        if (!proposalApprovalRequestsWithGenerated.some(request => request.approvalCategory === requirement.approvalCategory)) {
            proposalApprovalRequestsWithGenerated.push({
                ...requirement,
                approvalStatus: statusList[0],
            })
        }
    })
    // const initialApproverIds = data.proposalApprovalRequests.map(request => request.requestedApprover.pkStaffid);

    const {control, register, getValues} = useForm({
        values: {
            proposalApprovalRequests: proposalApprovalRequestsWithGenerated
        },
    });


    const {append, remove, fields} = useFieldArray({
        control,
        name: 'proposalApprovalRequests',
    });

    const validApprovers: Approvers = {};
    const approversLookup = {};
    // const staffRequestedForApproval = fields?.map(v => `${v.requestedApprover.stfFirstname} ${v.requestedApprover.stfLastname}`) || []
    Object.entries(approvers).forEach(([groupName, staffInGroup]) => {
        staffInGroup.forEach((staff) => {
            approversLookup[staff.pkStaffid] = {...staff, approvalLevel: groupName.split(' ')[0].toUpperCase()};
        });
        // if (staffInGroup?.length) validApprovers[groupName] = staffInGroup;
        validApprovers[groupName] = staffInGroup;
    });


    return (
        <>
            <h3>Proposal Approval</h3>
            <div className="mb-4">
                <div>
                    {queueMode &&
                        <p className='text-body-emphasis'>Proposal not yet ready to be approved, any approval requests
                            made
                            will
                            be queued up and sent when all required reviews have been completed.</p>}
                    {queueMode && fields.length ?
                        <strong>Queued Approval Requests</strong> : ''}

                    {queueMode && fields.some((v) => v.emailed) &&
                        <div className='text-body-secondary'><small><strong>Previously available for Approval but
                            current Reviews incomplete</strong></small></div>
                    }
                    {queueMode && data.proposalReviews.some(v => v.reviewStatus == 'Accepted, Changed') &&
                        <ul className='mb-0'>
                            <li><small className='text-body-secondary'>A review that was previously 'Accepted' is now
                                'Accepted, Changed' due to a change in the Proposal</small></li>
                        </ul>
                    }


                    <table className="styled">
                        <tbody>
                        {approvalRequirementList.map((approvalRequirement) =>
                            <>
                                <tr>
                                    <td style={{paddingBottom: '0.2em', verticalAlign: 'top'}}>
                                            <span style={{
                                                fontWeight: 'bold',
                                                fontSize: '0.9em',
                                                color: approvalRequirement.active ? 'darkslategray' : 'lightslategray',
                                            }}>
                                                {approvalRequirement.approvalCategory}
                                            </span>

                                    </td>
                                    <td style={{paddingBottom: '0.2em'}}>
                                        <ul className="ps-3 m-0">
                                            {!approvalRequirement.active ?
                                                <span className="text-body-secondary">Approval previously requested, but approval of this category no longer necessary</span> : approvalRequirement.approvalRequirementDetails?.map(detail =>
                                                    <li>{detail}</li>)}
                                        </ul>
                                    </td>
                                </tr>
                                {fields.filter(f => f.approvalCategory === approvalRequirement.approvalCategory).map((item) => {
                                        const index = fields.indexOf(item);
                                        const itemPermissions = data.permissions['proposal_approval_request']?.[getValues(`proposalApprovalRequests`)?.[index]?.id];


                                        return <ApprovalRequestRow
                                            approvalRequirement={approvalRequirement}
                                            approversLookup={approversLookup}
                                            data={data}
                                            index={index}
                                            item={item}
                                            itemPermissions={itemPermissions}
                                            queueMode={queueMode}
                                            register={register}
                                            statusList={statusList}
                                            inactive={!approvalRequirement.active}
                                            key={item.id}
                                            control={control}
                                            disabled={disabled}
                                            validApprovers={validApprovers}
                                        />
                                    }
                                )
                                }
                            </>
                        )}
                        </tbody>
                    </table>

                </div>
            </div>
        </>
    )
}


